import { render, staticRenderFns } from "./CustomProject.vue?vue&type=template&id=560b7488&scoped=true"
import script from "./CustomProject.vue?vue&type=script&lang=js"
export * from "./CustomProject.vue?vue&type=script&lang=js"
import style0 from "./CustomProject.vue?vue&type=style&index=0&id=560b7488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b7488",
  null
  
)

export default component.exports